import { useEffect } from "react";
import { applyTheme } from "../lib/theme";
import usePublicSettings from "../lib/usePublicSettings";

/**
 * Mounted at the very top of the public tree. Pulls the tenant theme
 * (primary + secondary) from the public settings and sets --p / --s / --p-ink / --s-ink.
 */
export default function PublicThemeProvider({ children }) {
  const { settings } = usePublicSettings();
  useEffect(() => {
    applyTheme({ primary: settings?.primary_color, secondary: settings?.secondary_color });
  }, [settings?.primary_color, settings?.secondary_color]);
  return children;
}
